import React from "react";
import { Avatar, Box, IconButton, Skeleton, Typography } from "@mui/material";

import { colors } from "../../theme/palette";
import { CloseCompareIcon } from "../../assets/icons/MUI/NetworkIcons";
import { useDataFormatter } from "../../hooks/useDataFormatter";

const CompareCard = React.memo(
  ({
    user,
    clearPersona,
  }: {
    user: any;
    clearPersona: (id: number) => void;
  }) => {
    const { fullName, firstTwoChr, media, role, id } = useDataFormatter(user);

    return (
      <Box
        sx={{
          position: "relative",
          borderRadius: "8px",
          border: `1px solid ${colors.Gray100}`,
          background: colors.white,
          padding: "13px 8px 8px",
          display: "flex",
          flexDirection: "column",
          rowGap: "5px",
          justifyItems: "center",
          margin: "0 auto",
          width: "148px",
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: "4px", right: "7px" }}
          onClick={() => {
            if (id) clearPersona(id);
          }}
        >
          <CloseCompareIcon
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </IconButton>
        <Avatar
          sx={{
            width: "50px",
            height: "50px",
            margin: "0 auto",
          }}
          src={media}
        >
          {firstTwoChr}
        </Avatar>
        <Typography
          variant="body14Bold"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: colors.Dark1000,
          }}
        >
          {fullName}
        </Typography>
        <Typography
          variant="body13Regular"
          sx={{ color: colors.Dark600, textAlign: "center" }}
        >
          {role}
        </Typography>
      </Box>
    );
  }
);

export default CompareCard;

export const CompareLoadingCard = () => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "8px",
        border: `1px solid ${colors.Gray100}`,
        background: colors.white,
        padding: "13px 8px 8px",
        display: "flex",
        flexDirection: "column",
        rowGap: "5px",
        justifyItems: "center",
        margin: "0 auto",
        width: "148px",
      }}
    >
      <IconButton
        sx={{ position: "absolute", top: "4px", right: "7px" }}
        disabled
      >
        <CloseCompareIcon
          style={{
            width: "20px",
            height: "20px",
          }}
        />
      </IconButton>

      <Skeleton
        variant="circular"
        width={50}
        height={50}
        sx={{ margin: "0 auto" }}
      />

      <Typography
        variant="body14Bold"
        sx={{
          fontWeight: 700,
          textAlign: "center",
          margin: "0 auto",
        }}
      >
        <Skeleton width="108px" />
      </Typography>

      <Typography variant="body13Regular" sx={{ margin: "0 auto" }}>
        <Skeleton width="60px" />
      </Typography>
    </Box>
  );
};
